import { Component, computed, input, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';
import { Tag } from '@shared/models/tag.model';
import { IconService } from '@ess-front/shared';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'ess-tag',
  imports: [CommonModule, TranslocoDirective],
  templateUrl: './tag.component.html',
  styleUrl: './tag.component.scss',
})
export class TagComponent {
  tag = input.required<Tag>();
  icon: Signal<SafeHtml | null> = computed(() => (this.tag().icon ? this.iconService.getSVG(this.tag().icon) : null));

  constructor(private iconService: IconService) {}
}
